import React from "react";
import MenuCard from "./MenuCard";

const Menu = () => {
  return (
    <section id="menu">
      <h1>Menu</h1>
      <div>
        <MenuCard
          handler={() => {}}
          imgSrc={
            "https://img.freepik.com/premium-photo/angoori-rasmalai-is-indian-dessert-sweet-with-dry-fruits-saffron-toppings-served-bow-selective-focus_726363-1072.jpg"
          }
          itemNum={1}
          price={790}
          title={"Ras Malai"}
          delay={0.1}
        />
        <MenuCard
          handler={() => {}}
          imgSrc={
            "https://www.yumcurry.com/wp-content/uploads/2019/09/Mishti-doi.png"
          }
          itemNum={2}
          price={430}
          title={"Mishti doi"}
          delay={0.5}
        />
        <MenuCard
          handler={() => {}}
          imgSrc={
            "https://www.yummytummyaarthi.com/wp-content/uploads/2014/10/5.jpg"
          }
          itemNum={3}
          price={440}
          title={"Roshgolla"}
          delay={0.8}
        />
      </div>
    </section>
  );
};

export default Menu;
